import React from "react";
import { Button } from "antd";

const CustomButton = ({
  type = "default",
  text,
  icon,
  onClick,
  loading = false,
  style = {},
  className = "",
}) => {
  return (
    <Button
      type={type}
      className={`flex justify-center items-center ${className}`}
      icon={icon}
      onClick={onClick}
      loading={loading}
      style={{
        borderRadius: "4px",
        border: "none",
        ...style, // Merge custom styles with defaults

      }}
    >
      {text}
    </Button>
  );
};

export default CustomButton;
